import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/MarsPeriodApi";
import store from "../../../../Frontends/Common/store";

export class MarsPeriodService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editMarsPeriod", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editMarsPeriod");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getMarsPeriods", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getMarsPeriod", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createMarsPeriod", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteMarsPeriod", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editMarsPeriod", model);
  }
  async import(gfid) {
    const res = this.Api.import(gfid);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold();
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async close(marsPeriodId) {
    return await this.Api.close(marsPeriodId);
  }
  async blockMarsPeriod(model) {
    return await this.Api.blockMarsPeriod(model);
  }
}
